define(
	'Home.View.Extension'
	, [
		'Home.View'
		, 'SC.Configuration'
		, 'Utilities.ResizeImage'
		, 'home.tpl'
		, 'Backbone'
		, 'jQuery'
		, 'underscore'
		, 'Utils'
		, 'Tracker'
	]
	, function (
		HomeView
		, Configuration
		, resizeImage
		, home_tpl
		, Backbone
		, jQuery
		, _
		, Utils
		, Tracker
	) {
		'use strict';
		_.extend(HomeView.prototype,
			{
				title: Utils.translate(Configuration.get('homepage.pageTitle', 'Appliance Parts Company | Repair and Replacement Appliance Parts'))

				, page_header: Utils.translate(Configuration.get('homepage.pageTitle', 'Appliance Parts Company | Repair and Replacement Appliance Parts'))

				, initSlider: function () {
					_.initBxSlider(this.$('[data-slider]'), {
						nextText: '<a class="home-gallery-next-icon"></a>'
						, prevText: '<a class="home-gallery-prev-icon"></a>'
						, speed: 500
						, pause: 5000
						, controls: true
						, auto: true
						, autoStart: true
						, touchEnabled: true
					});
				}

				, initialize: function () {
					var self = this;
					this.windowWidth = jQuery(window).width();
					this.options.application.getLayout().on('afterAppendView', this.initSlider, this);

					var windowResizeHandler = _.throttle(function () {
						if (_.getDeviceType(this.windowWidth) === _.getDeviceType(jQuery(window).width())) {
							return;
						}
						this.showContent();

						_.resetViewportWidth();

						this.windowWidth = jQuery(window).width();

					}, 1000);

					this._windowResizeHandler = _.bind(windowResizeHandler, this);

					jQuery(window).on('resize', this._windowResizeHandler);
				}

				// @method getContext @return Home.View.Context
				, getContext: function () {
					var carouselImages = _.map(Configuration.get('homepage.carouselImages', []), function (data) {
						return {
							title: data.headline
							, details: data.details
							, href: data.href
							, image: Utils.getAbsoluteUrlOfNonManagedResources(data.image)
							, linkname: data.linkname
						};
					});

					var subCategoriesLinks = _.map(Configuration.get('subCategories.subCategoriesLinks', []), function (data) {
						return {
							url: data.url
							, caption: data.caption
						};
					});

					var brandImages = _.map(Configuration.get('brandImages.brandImages', []), function (data) {
						return {
							url: data.url
							, image: Utils.getAbsoluteUrlOfNonManagedResources(data.image)
							, alt: data.alt
						};
					});

					var bottomBannerImages = _.map(Configuration.get('homepage.bottomBannerImages', []), function (url) {
						return Utils.getAbsoluteUrlOfNonManagedResources(url);
					});
					return {
						// @class Home.View.Context
						// @property {String} imageResizeId
						imageHomeSize: Utils.getViewportWidth() < 768 ? 'homeslider' : 'main'
						// @property {String} imageHomeSizeBottom
						, imageHomeSizeBottom: Utils.getViewportWidth() < 768 ? 'homecell' : 'main'

						// @property {Array} bottomBannerImages
						, bottomBannerImages: bottomBannerImages

						//EideBailly: custom

						// @property {Array} carouselImages
						, carouselImages: carouselImages
						// @property {Array} subCategoriesLinks
						, subCategoriesLinks: subCategoriesLinks
						// @property {Array} brandImages
						, brandImages: brandImages

						// @class Home.View
					};
				}
			});
	});
